import React from 'react'

export default ({ id, name, type, label, placeholder, ...props }) => (
  <div className="field">
    <label htmlFor="email">{label}</label>
    <input 
      id={id || name} 
      {...props}
      name={name} 
      className="on"
      type={type || 'text'} 
      placeholder={label}
    />
  </div>
)


// WEBPACK FOOTER //
// ./src/views/shared/labelInput.js